import React, { useState } from "react";
import "./pages.css";
import circleInfo from "./circle-info.svg";
import { useAuth } from "react-oidc-context";

const Homepage = () => {
  const [companyID, setCompanyID] = useState('');
  const auth = useAuth();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (companyID.trim()) {
      sessionStorage.setItem('companyID', companyID.trim());
      auth.signinRedirect({extraQueryParams : { acr_values: "tenant:"+  sessionStorage.getItem('companyID')}});
      ;
    }
  };

  return (
    <div className="login-page">
      <div className="page-container">
        <div>
          <div className="heading">Welcome to Retain API Doc</div>
          <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              className="form-control-input"
              placeholder="Company ID"
              type="text"
              value={companyID}
              onChange={(e) => setCompanyID(e.target.value)}
            />
            <div className="icon">
              <img src={circleInfo} alt="info" />
              <div className="tooltip">
                Your company ID will have been in your invitation email. It's
                the first part of your Retain Cloud URL after retaincloud.com/
                <span>
                  e.g. retaincloud.com/<b>companyid</b>
                </span>
              </div>
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn" name="button" value="login">
              Log in
            </button>
          </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
